<template>
  <el-dialog :visible.sync="show" title="历史记录" width="600px">
    <div class="list" v-loading="isLoading">
      <el-table
        border
        stripe 
        ref="multipleTable"
        :data="list"
        v-loading="isLoading"
      >
        <el-table-column
          prop="createTime"
          label="操作时间"
          min-width="120">
          <template slot-scope="{ row }">
            <div>{{ row.createTime | filterTime }}</div>
          </template> 
        </el-table-column>
        <el-table-column
          prop="createBy"
          label="操作人"
          min-width="120"></el-table-column>
        <el-table-column
          prop="channelDeduction"
          label="配置渠道固定扣点(%)"
          min-width="120"> 
          <template slot-scope="{ row }">
            <div>{{ row.channelDeduction ? row.channelDeduction / 1000 : '--' }}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer">
      <el-button size="mini" @click="$emit('close')">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getChannelDeductionHistory } from '@/service/apis/streamAccount'
import moment from 'moment'
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: () => {}

    }
  }, 
  filters: {
    filterTime (val) {
      if (!val) {
        return '--'
      }
      return moment(val).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    show: {
      immediate: true,
      handler (val) {
        if (val) {
          this.getList()
        }
      }
    }
  },
  data () {
    return {
      isLoading: false,
      list: []
    }
  },
  methods: {
    getList () {
      this.isLoading = true
      getChannelDeductionHistory.call(this, {
        accountId: this.row.accountId
      }).then(res => {
        this.list = [...(res || [])]
      }).finally(() => {
        this.isLoading = false
      })
    }
  }
}
</script>

<style scoped>
</style>